import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import StatusContext from '../../../contexts/StatusContext'
import CustomTemplatesContext from '../../../contexts/CustomTemplatesContext'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {ScrollText} from "../scrolltext/ScrollText"
import { PushButton } from '../pushbutton/PushButton';
import { useState } from "react";

import "./customtemplates.css"

export const DialogNewPrompt = () => {

  const [status, setStatus] = useState('')
  
  const {
    changeLanguage,
} = React.useContext(StatusContext);


const {
  addPrompt,
  updatePrompt,
  newPrompt,
  setNewPrompt,
  showNewPromptDialog,
  setShowNewPromptDialog,
  editmode,
  
} = React.useContext(CustomTemplatesContext);

const isNewPromptValid = newPrompt && typeof newPrompt === 'object'


const handleChangeWho = (event) => {
  event.target.style.height = 'auto';
  event.target.style.height = `${event.target.scrollHeight}px`;
 
  // Create a new object for newPrompt
  const updatedNewPrompt = {...newPrompt}
 
  updatedNewPrompt.who = event.target.value // Update the title
 
  setNewPrompt(updatedNewPrompt)
};


const handleChangeWhat = (event) => {
  event.target.style.height = 'auto';
  event.target.style.height = `${event.target.scrollHeight}px`;
  
   // Create a new object for newPrompt
   const updatedNewPrompt = {...newPrompt}
 
   updatedNewPrompt.what = event.target.value // Update the data
  
   setNewPrompt(updatedNewPrompt)
};

const handleAdd = async (e) => {
  
  // Add new prompt
  addPrompt(newPrompt);
  handleClose();
};

const handleUpdate = async (e) => {
  console.log("Updateprompt:", newPrompt)
 
  if (newPrompt.what === "") {
    setStatus(changeLanguage("templates", "newpromptempty"));
    return;
  }

  // Update prompt
  updatePrompt(newPrompt);
  handleClose();
};

const handleClose = () => {

  setStatus('')
  
  setShowNewPromptDialog(false)
  setNewPrompt({
    id:0,
    who:"",
    what:""
  })

};

  return (
   
    <React.Fragment>
   
        <Dialog
          open={showNewPromptDialog}
         
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
            },
          }}
        >

        <DialogTitle className="dialogTitleModifyTest">{newPrompt && editmode ? `(${newPrompt.id})` : ""}{!editmode ? changeLanguage('templates', 'dialognewprompt') : changeLanguage('templates', 'dialogupdateprompt')}</DialogTitle>

        <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
       <CloseIcon />
      </IconButton>

        <DialogContent dividers>
          <div >
              <label style={{fontSize:'12px'}}>{changeLanguage('templates', 'addprompt_label1')}</label> 
              <ScrollText rows={2} text={isNewPromptValid ? newPrompt.who : ''} onChange={handleChangeWho} />
              <br></br>
           
              <label style={{fontSize:'12px'}}>{changeLanguage('templates', 'addprompt_label2')}</label>
              <ScrollText rows={6}  text={isNewPromptValid ? newPrompt.what : ''} onChange={handleChangeWhat}/>
              <br></br>
              <br></br>
              <PushButton label={!editmode ? changeLanguage('templates','add') : changeLanguage('templates','update')} disablebutton = {!newPrompt || newPrompt.what.length === 0} onClick={!editmode ? handleAdd : handleUpdate}/>
              <br></br>
 
              {
                (status) && <label>{status}</label>
              }
          </div>
          
        </DialogContent>
      </Dialog>
    </React.Fragment>
    
  );
  
}